import React, { useRef } from 'react'
import styles from './Price.module.scss'
import Button from 'components/common/Button/Button'

const Price: React.FC = () => {
  return (
    <section className={styles.price}>
      <div className={styles.inner}>
        <h2 className={styles.price__title}>料金</h2>
        <div className={styles.price__box}>
          <p className={styles.price__box__text}>リーズナブルな料金設定、詳細は以下からお気軽にお問い合わせください</p>
          <div className={styles.price__box__link}>
            <Button text="お問い合わせ" href="/contact/" red="red" />
          </div>
        </div>
      </div>
    </section>
  )
}
export default Price
